import React from 'react';
import { ResourceMatchResult } from '@/types/recommendation';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';
import { ConflictResourceCard } from './ConflictResourceCard';

interface ConflictResourceListProps {
  results: ResourceMatchResult[];
  hasCleanMatches: boolean;
  requestedStart: Date;
  requestedEnd: Date;
  pendingResourceIds?: string[];
  onToggle?: (result: ResourceMatchResult) => void;
}

export function ConflictResourceList({
  results,
  hasCleanMatches,
  requestedStart,
  requestedEnd,
  pendingResourceIds = [],
  onToggle,
}: ConflictResourceListProps) {
  if (results.length === 0) return null;

  const defaultValue = !hasCleanMatches ? 'conflict-list' : undefined;

  return (
    <div className="mt-3">
      <Accordion type="single" collapsible defaultValue={defaultValue}>
        <AccordionItem value="conflict-list" className="border-0">
          <AccordionTrigger className="hover:no-underline py-1.5 px-0 group">
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider group-data-[state=open]:text-foreground transition-colors">
                Available with conflicts
              </span>
              <Badge variant="warning" accent="warning" className="text-[10px] px-1.5 py-0 h-4">
                {results.length}
              </Badge>
            </div>
          </AccordionTrigger>
          <AccordionContent className="pb-1 pt-0">
            <div className="space-y-1.5">
              {results.map(r => (
                <ConflictResourceCard
                  key={r.resource.id}
                  result={r}
                  requestedStart={requestedStart}
                  requestedEnd={requestedEnd}
                  isSelected={pendingResourceIds.includes(r.resource.id)}
                  onToggle={onToggle}
                />
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
